import React from 'react';
import PropTypes from 'prop-types';
import { AssetClassesTable } from './components/AssetClassesTable';
import { Link } from '../../../CommonComponents/OPL/Link/Link';
import { AssetClassesLoading } from './AssetClasses.loading';
import { Text } from '../../../CommonComponents/OPL/Text/Text';

class AssetClassesView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchQuery: '',
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSaveMapping = this.handleSaveMapping.bind(this);
  }

  componentDidMount() {
    const { fetchAssetClasses } = this.props;
    fetchAssetClasses();
  }

  componentWillUnmount() {
    const { resetState } = this.props;
    resetState();
  }

  handleSearchChange(value) {
    this.setState({ searchQuery: value });
  }

  handleSaveMapping(mappedAssetClasses, originalIndex) {
    const { saveAssetClasses } = this.props;
    saveAssetClasses(mappedAssetClasses, originalIndex);
  }

  render() {
    const { assetClassesOptions, assetClassMappings, hasLoaded } = this.props;
    const { searchQuery } = this.state;

    return (
      <div>
        <Text
          as="h2"
          fontSize="h6"
          color="neutral.700"
          display="flex"
          mb="40"
          css="align-items: baseline"
        >
          For more Orion Planning asset class information please&nbsp;
          <Link
            href="https://orionadvisorservices.my.site.com/OrionSupportApp/s/article/Orion-Planning-Asset-Class-Mapping"
            target="_blank"
            rel="noreferrer noopener"
            isExternal
          >
            click here.
          </Link>
        </Text>
        {!hasLoaded ? (
          <AssetClassesLoading />
        ) : (
          <AssetClassesTable
            assetClassesOptions={assetClassesOptions}
            assetClassMappings={assetClassMappings}
            searchQuery={searchQuery}
            onSearchChange={this.handleSearchChange}
            onSaveMapping={this.handleSaveMapping}
          />
        )}
      </div>
    );
  }
}

AssetClassesView.propTypes = {
  assetClassesOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  assetClassMappings: PropTypes.arrayOf(
    PropTypes.shape({
      ExternalAssetClassName: PropTypes.string,
    }),
  ).isRequired,
  fetchAssetClasses: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  saveAssetClasses: PropTypes.func.isRequired,
  resetState: PropTypes.func.isRequired,
};

export default AssetClassesView;
